import { defineStyleConfig } from '@chakra-ui/system';

export const FormLabel = defineStyleConfig({
    baseStyle: {
        margin: '0 0 4px 0',
        textStyle: 'slt-body-text-lg',
        fontSize: '1.125rem',
        fontWeight: 500,
        color: 'slt-black.900',
    },
    variants: {
        'new-style': {
            textStyle: 'body-base',
            fontWeight: 500,
            color: 'slt-pepper.1000',
            fontSize: '1rem',
        },
        'no-margin': {
            margin: 0,
        },
    },
});
